import { readEnv } from '@app/config/runtime'

function trimTrailingSlash(value: string) {
  return value.endsWith('/') ? value.slice(0, -1) : value
}

export function getHanaspeakApiBaseUrl() {
  const configuredBaseUrl = readEnv(
    'VITE_HANASPEAK_API_BASE_URL',
    'REACT_APP_HANASPEAK_API_BASE_URL',
  ).trim()

  if (configuredBaseUrl) {
    return trimTrailingSlash(configuredBaseUrl)
  }

  const projectId = readEnv('VITE_FIREBASE_PROJECT_ID', 'REACT_APP_PROJECT_ID').trim()

  if (!projectId) {
    throw new Error('Hanaspeak API base URL is not configured for this environment.')
  }

  return `https://asia-east2-${projectId}.cloudfunctions.net/api`
}
